/**
 * Animations class
 */
class Animations {
	/**
	 * Constructor
	 */
	constructor() {
		this.animationSettings = [
			{
				class: 'gt-fade-up',
			},
			{
				class: 'gt-fade-up-row',
				target: '[class^="module-"]',
				delay: 0.2,
			},
			{
				class: 'gt-each-item-animation > *',
			},
		];
		this.elemTriggers = [];
		this.observerOptions = {
			rootMargin: '0px 0px -20% 0px',
			threshold: 0,
		};
		this.observer = new IntersectionObserver(this.scrollAnimationsHandler, this.observerOptions);
	}

	/**
	 * Initialize class
	 *
	 * @return {void}
	 */
	init() {
		// Finds and animates elements
		this.findAnimationTriggers();
		this.animateElements(this.animationSettings);
	}

	/**
	 * Finds elements to animate and returns array with elements found
	 *
	 * @return {void}
	 */
	findAnimationTriggers() {
		for (const item of this.animationSettings) {
			const elements = document.querySelectorAll('.' + item.class);

			for (const elem of elements) {
				this.elemTriggers.push(elem);
				this.observer.observe(elem);
			}
		}
	}

	/**
	 * Find child elements and animate each child
	 *
	 * @param {Array} settings
	 * @return {void}
	 */
	animateElements(settings) {
		for (const elemTrigger of this.elemTriggers) {
			for (const setting of settings) {
				if (elemTrigger.classList.contains(setting.class) && setting.target) {
					elemTrigger.querySelectorAll(setting.target).forEach((element, index) => {
						element.style.transitionDelay = setting.delay * index + 's';
					});
				}
			}
		}
	}

	/**
	 * Scroll trigger event handler
	 *
	 * @param {Object} entries
	 * @return {void}
	 */
	scrollAnimationsHandler(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('animate');
			}
		});
	}
}

const runAnimations = () => {
	if (document.querySelector('.gt-animations-activated')) {
		const animations = new Animations();
		animations.init();
	}
};

// If document is already ready
if (document.readyState === 'complete') {
	runAnimations();
} else {
	document.addEventListener('DOMContentLoaded', runAnimations);
}
